var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-4",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,17 L16,22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,22 L27,11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmBold);
export default __webpack_public_path__ + "static/media/confirmBold.34484d0e4fa221f15d023e682145de6c.svg";
export { ForwardRef as ReactComponent };